/*
  This file and all its exported members are deprecated.
  GraphQL is deprecated in app v2.
  It will be removed when we migrate documents-service-backend from GraphQL to REST API
  This is the Epic to track this work: https://clipboardhealth.atlassian.net/browse/CH-23128
*/

// eslint-disable-next-line no-restricted-imports
import { gql } from "@apollo/client";
// eslint-disable-next-line no-restricted-imports
import { print } from "graphql";

const DEPRECATED_DO_NOT_USE_GRAPHQL_GET_DISTRIBUTION_URL_GQL = gql`
  query GET_DISTRIBUTION_URL($docId: ObjectId!, $shiftId: ObjectId) {
    getDistributionUrl(docId: $docId, shiftId: $shiftId) {
      distributionUrl
    }
  }
`;

const DEPRECATED_DO_NOT_USE_GRAPHQL_GET_PRESIGNED_UPLOAD_URL_GQL = gql`
  query GET_PRESIGNED_UPLOAD_URL($reqId: ObjectId!, $fileType: String!) {
    getPresignedUploadUrl(reqId: $reqId, fileType: $fileType) {
      preSignedUrl
      fileStorageRootFolder
      fileStorageFileKey
    }
  }
`;

/**
 * @deprecated This function is deprecated and will be removed when we migrate from GraphQL to REST API.
 * This is the ticket to migrate this endpoint: https://clipboardhealth.atlassian.net/browse/CH-23129
 * FIXME(CH-23129): Remove this endpoint after migrating to REST API
 */
export const DEPRECATED_DO_NOT_USE_GET_DISTRIBUTION_URL = print(
  DEPRECATED_DO_NOT_USE_GRAPHQL_GET_DISTRIBUTION_URL_GQL
);

/**
 * @deprecated This function is deprecated and will be removed when we migrate from GraphQL to REST API.
 * This is the ticket to migrate this endpoint: https://clipboardhealth.atlassian.net/browse/CH-23195
 * FIXME(CH-23195): Remove this endpoint after migrating to REST API
 */
export const DEPRECATED_DO_NOT_USE_GET_PRESIGNED_UPLOAD_URL = print(
  DEPRECATED_DO_NOT_USE_GRAPHQL_GET_PRESIGNED_UPLOAD_URL_GQL
);
